const config = {
  API_BASE_URL: process.env.NODE_ENV === 'production' 
    ? 'https://deathlist.onrender.com/api' 
    : 'http://localhost:3000/api'
};

export default config; 